import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import {
  CloudDownload as CloudDownloadIcon,
  Psychology as PsychologyIcon,
  Language as LanguageIcon
} from '@mui/icons-material';
import { DownloadedWebpage } from '../../types/index';
import WebpageDownloadTab from './WebpageDownloadTab';
import QAGenerationTab from './QAGenerationTab';
import WebpageCrawlingTab from './WebpageCrawlingTab';
import TabPanel from '../TabPanel';

interface WebpageInputTabProps {
  aiId: string;
  collectionId: string;
  onQAGenerated: (addedPairs: any[]) => void;
  onRefreshQnaPairs?: () => void;
}

const WebpageInputTab: React.FC<WebpageInputTabProps> = ({ 
  aiId,
  collectionId,
  onQAGenerated,
  onRefreshQnaPairs
}) => {
  const [tabValue, setTabValue] = useState(0);
  const [downloadedWebpages, setDownloadedWebpages] = useState<DownloadedWebpage[]>([]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleDownloadedWebpagesChange = (webpages: DownloadedWebpage[]) => {
    setDownloadedWebpages(webpages);
  };




  return (
    <Box>
      <Typography variant="body2" color="text.secondary" paragraph>
        Download individual webpages, crawl entire websites, or generate Q&A pairs from downloaded content using our three-step process.
      </Typography>

      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="fullWidth"
          aria-label="Webpage processing tabs"
        >
          <Tab 
            icon={<CloudDownloadIcon />} 
            label="Download Webpages" 
            id="webpage-tab-0" 
            aria-controls="webpage-tabpanel-0" 
          />
          <Tab 
            icon={<LanguageIcon />} 
            label="Crawl Website" 
            id="webpage-tab-1" 
            aria-controls="webpage-tabpanel-1" 
          />
          <Tab 
            icon={<PsychologyIcon />} 
            label="Generate Q&A" 
            id="webpage-tab-2" 
            aria-controls="webpage-tabpanel-2" 
          />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <WebpageDownloadTab
            aiId={aiId}
            collectionId={collectionId}
            onDownloadedWebpagesChange={handleDownloadedWebpagesChange}
            onRefreshQnaPairs={onRefreshQnaPairs}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <WebpageCrawlingTab
            aiId={aiId}
            collectionId={collectionId}
            onCrawledWebpagesChange={handleDownloadedWebpagesChange}
            onRefreshQnaPairs={onRefreshQnaPairs}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <QAGenerationTab
            aiId={aiId}
            collectionId={collectionId}
            downloadedWebpages={downloadedWebpages}
            onDownloadedWebpagesChange={handleDownloadedWebpagesChange}
            onQAGenerated={onQAGenerated}
            onRefreshQnaPairs={onRefreshQnaPairs}
          />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default WebpageInputTab;